<template style="overflow-y: hidden;">
    <!-- 弹框资金使用申请 -->
    <div style="overflow-y: hidden;">
        
        <el-dialog v-dialogDrag :title="applyCode === 'FP' ? '发票申请' : '资金使用申请'"  width="85%" :show-close="true"
            :close-on-click-modal="false" :visible.sync="dialogFormVisible" :before-close="beforeclose">
            <el-button type="primary" size="mini" plain @click="saveHeader('form')" style="margin-left: 20px;">提交申请</el-button>
            <el-form :model="form" ref="form" :rules="rules" label-width="100px" :inline="true"  class="demo-form-inline" size="small">
                <el-form-item label="单据编号">
                    <el-input class="width_250"  disabled clearable v-model.trim="form.billNo" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item  label="往来单位" prop="company">
                    <el-input class="width_250"  disabled clearable v-model="form.company" autocomplete="off"></el-input>
                    <!-- <el-select class="width_250" disabled @change="selectCompany" filterable v-model.trim="form.company"
                        placeholder="请选择往来单位">
                        <el-option v-for="item in customOption" :key="item.id" :label="item.name"
                            :value="{ value: item.id, label: item.name }">
                        </el-option>
                    </el-select> -->
                    <!-- <el-input v-model.trim="form.company" autocomplete="off"></el-input> -->
                </el-form-item>
                <el-form-item disabled  label="币制" prop="currency">
                    <el-select class="width_250" disabled filterable v-model="form.currency" placeholder="请选择币制">
                        <el-option v-for="item in typeOption" :key="item.id" :label="item.value"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <!-- <el-input v-model.trim="form.currency" autocomplete="off"></el-input> -->
                </el-form-item>
                    <!-- <el-col :span="6" v-if="applyCode !== 'FP'">
                        <el-form-item  label="银行账号" prop="bank">
                            <el-select filterable clearable v-model.trim="form.bank" placeholder="请选择银行帐号" @change="selectBank">
                                <el-option v-for="item in bankOption" :key="item.id" :label="item.bankName"
                                    :value="{ value: item.accountNum, label: item.bankName }">
                                    <span style="float: left">{{ item.bankName }}</span>
                                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.accountNum
                                        }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                <el-form-item  label="金额" prop="amount">
                    <el-input class="width_250" clearable v-model.number="form.amount" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item v-if="applyCode !== 'FP'"  label="发票情况" prop="invoiceType">
                    <el-select  class="width_250" filterable v-model="form.invoiceType" placeholder="请选择业务类型">
                        <el-option v-for="item in invoiceTypeList" :key="item.value" :label="item.value"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="applyCode !== 'FP'"  label="发票号" :prop="form.invoiceType === '有发票' ? 'voucherNo' : ''">
                    <el-input class="width_250"  clearable v-model.trim="form.voucherNo" autocomplete="off"></el-input>
                </el-form-item>
                <el-row>
                    <el-col :span="101">
                        <el-form-item label="开票信息" prop="invoiceInfo" style="width: 100%;">
                            <el-input type="textarea"  :autosize="{ minRows: 2, maxRows: 4}" clearable v-model="form.invoiceInfo" autocomplete="off" style="width: 610px;"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11"> 
                        <el-form-item label="备注" prop="note">
                            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" clearable v-model="form.note" autocomplete="off" style="width: 610px;"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="上传供应商账单">
                            <el-upload class="upload-demo" :action="saveOneAttachmentURL" :on-remove="handleRemoveGYS" :on-change="handleChangeGYS"
                            multiple :file-list="fileListGYS" :auto-upload="false">
                                <el-button  l-button size="mini" type="primary">选择文件</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="上传发票">
                            <el-upload class="upload-demo" :action="saveOneAttachmentURL" :on-remove="handleRemoveFP" :on-change="handleChangeFP"
                            multiple :file-list="fileListFP" :auto-upload="false">
                                <el-button  l-button size="mini" type="primary">选择文件</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="上传报关单">
                            <el-upload class="upload-demo" :action="saveOneAttachmentURL" :on-remove="handleRemoveBGD" :on-change="handleChangeBGD"
                            multiple :file-list="fileListBGD" :auto-upload="false">
                                <el-button  l-button size="mini" type="primary">选择文件</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="上传其他">
                            <el-upload class="upload-demo" :action="saveOneAttachmentURL" :on-remove="handleRemoveQT" :on-change="handleChangeQT"
                            multiple :file-list="fileListQT" :auto-upload="false">
                                <el-button  l-button size="mini" type="primary">选择文件</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <!-- 明细表格展示 -->
            <div>
                <el-table height="500px" :data="detailData"  show-summary :summary-method="getSummaries"
                    border ref="detailData" style="width: 100%;font-size: 14px; margin-top: 20px;">
                    <el-table-column label="序号" type="index" width="60" align="center">
                    </el-table-column>
                    <el-table-column prop="blNo" label="提单号" align="center"> </el-table-column>
                    <el-table-column prop="subNo" label="分单号" align="center"> </el-table-column>
                    <el-table-column prop="containerNo" label="箱号" align="center"> </el-table-column>
                    <el-table-column prop="feeName" label="费用名称" align="center"> 
                        <template slot-scope="scope">
                            <span class="ellipsis">{{ scope.row.feeName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="totalWt" label="结算金额" align="center">  
                        <template slot-scope="scope">
                            <span v-format="'#,##0.00'">{{ scope.row.totalWt }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="finance" label="余额" align="center">
                        <template slot-scope="scope">
                            <span v-format="'#,##0.00'">{{ scope.row.finance }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createMan" label="创建人" align="center">
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" align="center">
                    </el-table-column>
                    <el-table-column prop="note" label="备注" align="center">
                    </el-table-column>
                </el-table>
            </div>
            <!-- <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="mini" plain @click="saveHeader('form')">提交申请</el-button>
            </span> -->
        </el-dialog>
    </div>
</template>

<script>
import req from '@/utils/index.js'
import url from '@/config/url1.js'
import url1 from '@/config/url2.js'
export default {
    name: 'fastApplication',
    props: ['idArr','applyCode'],
    data() {
        return {
            isbig: false,
            remain: '',//结算金额显示余额
            headerId: '',//表头id
            detailtableData: [],//应付费用明细列表
            detailData: [],//应付明细数据
            // feeOption: [],//费用类型数据
            bankOption: [],
            typeOption: [],
            customOption: [],
            originalBankOption: [], // 用于存储初始的 bankOption，以便对比
            dialogFormVisible: false,
            form: {
                company: '',
                voucherNo: '',
                // bank: '',
                // bankAccount: '',
                note: '',//备注
                amount: '',
                currency: '',
                billNo: '',
                invoiceInfo:''
            },
            companyId: '',//公司id获取
            bh: '',
            invoiceTypeList:[ // 业务发票类型
                { value: '有发票', label: '有发票' },
                { value: '无发票', label: '无发票' },
                { value: '后来发票', label: '后来发票' },
            ], 
            rules: {
                company: [
                    { required: true, message: '请选择往来单位', trigger: 'change' }
                ],
                invoiceType: [
                    { required: true, message: '请选择发票情况', trigger: 'change' }
                ],
                voucherNo: [
                    { required: true, message: '请填写发票号', trigger: 'blur' }
                ],
                // bank: [
                //     { required: true, message: '请选择银行帐户', trigger: 'change' }
                // ],
                // bankAccount: [
                //     { required: true, message: '请选择活动资源', trigger: 'change' }
                // ],
                invoiceInfo:[
                    { required: true, message: '请填写开票信息', trigger: 'blur' }
                ],
                amount: [
                    { required: true, message: '请填写金额', trigger: 'blur' }
                ],
                currency: [
                    { required: true, message: '请选择币制', trigger: 'change' }
                ],
            },
            saveOneAttachmentURL:url1.saveOneAttachment, // 上传文件url
            fileListGYS:[],
            fileListFP:[],
            fileListQT:[],
            fileListBGD:[],
            businessId:'', //业务id
        }
    },
    updated() {
        //异步更新表格内数据
        // this.$nextTick(() => {

        //     this.$refs.detailData.doLayout();

        // });
    },
    watch: {
        'form.company': function (newValue, oldValue) {
            // 往来单位发生变化时检查币制是否也有值，如果都有值则调用接口
            if (newValue && this.form.currency) {
                // this.form.bank ='';
                // this.fetchBankAccounts();
                if (JSON.stringify(newValue) !== JSON.stringify(oldValue) && newValue && oldValue) {
                    // this.form.allBank = '';
                    // this.form.bank = '';
                    // this.form.bankAccount = ''
                }
            }
        },
        'form.currency': function (newValue, oldValue) {
            // 币制发生变化时检查往来单位是否也有值，如果都有值则调用接口
            if (newValue && this.form.company) {
                // this.form.bank ='';
                // this.fetchBankAccounts();
                if (JSON.stringify(newValue) !== JSON.stringify(oldValue) && newValue && oldValue) {
                    // this.form.allBank = '';
                    // this.form.bank = '';
                    // this.form.bankAccount = ''
                }

            }
        }
    },
    computed: {
    },
    created() {
        //获得基础数据
        // this.getcustomList();
        // this.getTypeOption();
        // this.getFeeList();
    },
    methods: {
        fastApply(id) {
            this.businessId = id
            let URL = `${url1.quickGenerate}${this.applyCode}`;
            req.post(URL, this.idArr).then(res => {
                if (res.data.code === 200) {
                    this.dialogFormVisible = true;
                    res.data.data.feeVoucher.invoiceInfo = ''
                    this.form = res.data.data.feeVoucher;
                    // 获取委托单位的开票信息
                    this.getcustomList(this.form.companyId);
                    // let bank = this.form.bank;
                    // this.form.bank = `${this.form.bankAccount}-${bank}`;
                    this.detailData = res.data.data.feeRecordList;
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    })
                }
            })
        },

        // 合计行
        //指定列求和
        // 合计金额
        // 合计行 方法
        getSummaries(param) {
            const { columns, data } = param
            const sums = []
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计'
                    return
                }
                // 这里添加需要进行合计的列的名称
                const sumColArr = ['结算金额', '余额']
                if (sumColArr.includes(column.label)) {
                    const values = data.map((item) => Number(item[column.property]))
                    if (!values.every((value) => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr)
                            if (!isNaN(value)) {
                                return prev + curr
                            } else {
                                return prev
                            }
                        }, 0)
                            .toFixed(2) // 固定两位小数
                        sums[index] += '' // 这里可以添加单位 如： sums[index] += '元'
                    } else {
                        sums[index] = ' '
                    }
                }
            })
            return sums
        },

        rowStyle() {
            return "text-align:center";
        },
        //费用名称
        // getFeeList() {
        //     let URL = `${url.fee}?feeName=`;
        //     req.get(URL).then(res => {
        //         if (res.data.code === 200) {
        //             this.feeOption = res.data.data;
        //         }
        //     })
        // },
        beforeclose() {
            this.detailData = [];
             this.$refs.form.resetFields();
            // this.form = {};
            this.dialogFormVisible = false;
            this.$parent.clearIdArr();
            this.$parent.reset(1);
            this.$parent.reset(2);
        },
        // selectCompany(data) {
        //     const { value, label } = data;
        //     // 对formValue中的银行code和银行名称重新赋值
        //     this.form.company = label;
        //     this.companyId = value;
        // },
        // selectBank(data) {
        //     const { value, label } = data;
        //     // 对formValue中的银行code和银行名称重新赋值
        //     // this.form.bank = value;
        //     this.form.bankAccount = value;
        //     this.form.bank = `${label}-${value}`;
        // },
        saveHeader(form) {
            this.$refs[form].validate((valid) => {
                if (valid) {
                    //深复制
                    let form = JSON.parse(JSON.stringify(this.form));
                    if(this.applyCode === 'FK'){
                        // form.bank = form.bank.split('-')[0];
                        form.flag = 'FK';
                    }else{
                        form.flag = 'FP';
                    }
                    let obj = {
                        feeVoucher: form,
                        feeRecordList: this.detailData
                    };
                    let URL = `${url1.quickInsVoucher}`
                    req.post(URL, obj).then(res => {
                        if (res.data.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '保存成功'
                            })
                            // 上传附件
                            this.sureUpload(res.data.data.split('|')[0])
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.message
                            })
                        }
                    })
                } else {
                    this.$message({
                        type: 'error',
                        message: '请填写必填项'
                    });
                }
            });
        },
        // 确认上传文件
        async sureUpload(voucherId){
                try {
                    // 创建Promise数组
                    // 供应商
                    if (this.fileListGYS.length > 0) {
                        const promisesGYS = this.fileListGYS.map(item => {
                            const formDataGYS = new FormData();
                            formDataGYS.append('file', item.raw);
                            formDataGYS.append('businessId', this.businessId);
                            formDataGYS.append('voucherId', voucherId);
                            formDataGYS.append('annexType', '供应商账单');
                            let fileUrl = `${url1.saveOneAttachment}`
                            return this.saveOneAttachment(fileUrl, formDataGYS);
                        });
                        await Promise.all(promisesGYS);
                    }
                    // 发票
                    if (this.fileListFP.length > 0) {
                        const promisesFP = this.fileListFP.map(item => {

                            const formDataFP = new FormData();
                            formDataFP.append('file', item.raw);
                            formDataFP.append('businessId', this.businessId);
                            formDataFP.append('voucherId', voucherId);
                            formDataFP.append('annexType', '发票');
                            let fileUrl = `${url1.saveOneAttachment}`
                            return this.saveOneAttachment(fileUrl, formDataFP);
                        });
                        await Promise.all(promisesFP);
                    }
                    // 报关单
                    if (this.fileListBGD.length > 0) {
                        const promisesBGD = this.fileListBGD.map(item => {
                            const formDataBGD = new FormData();
                            formDataBGD.append('file', item.raw);
                            formDataBGD.append('businessId', this.businessId);
                            formDataBGD.append('voucherId', voucherId);
                            formDataBGD.append('annexType', '报关单');
                            let fileUrl = `${url1.saveOneAttachment}`
                            return this.saveOneAttachment(fileUrl, formDataBGD);
                        });
                        await Promise.all(promisesBGD);
                    }
                     // 其他
                    if (this.fileListQT.length > 0) {
                        const promisesQT = this.fileListQT.map(item => {
                            const formDataQT = new FormData();
                            formDataQT.append('file', item.raw);
                            formDataQT.append('businessId', this.businessId);
                            formDataQT.append('voucherId', voucherId);
                            formDataQT.append('annexType', '其他');
                            let fileUrl = `${url1.saveOneAttachment}`
                            return this.saveOneAttachment(fileUrl, formDataQT);
                        });
                        await Promise.all(promisesQT);
                    }
                    // 完成后操作
                    this.fileListGYS = [];
                    this.fileListFP = [];
                    this.fileListBGD = [];
                    this.fileListQT = [];
                } catch (error) {
                    this.$message.error('上传失败: ' + error.message);
                }
            this.dialogFormVisible = false;
        },
        //    调用上传文件接口
        saveOneAttachment(fileUrl,formData){
            return  req.post(fileUrl,formData).then(res => {
                if (res.data.code === 200) {
                }else{
                    that.$message({
                        type: 'warning',
                        message: res.data.message
                    });
                }
            })
        },
        //获取银行账号密码
        // fetchBankAccounts() {
        //     let URL = `${url1.getBankInfo}/${this.companyId}/${this.form.currency}`;
        //     req.get(URL).then(res => {
        //         if (res.data.code === 200) {
        //             this.bankOption = res.data.data;
        //             // this.form.bank = res.data.data.bank;
        //             // this.form.bankAccount = res.data.data.bankAccount;
        //         }
        //     })
        // },
        //获取委托单位数据
        getcustomList(data) {
            let URL = `${url1.getById}/`+ data;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.form.invoiceInfo = res.data.data.invoiceInfo;
                    this.$forceUpdate()
                }
            })
        },
        //获得币制数据
        getTypeOption() {
            let value = '币制';
            let URL = `${url.getDicList}/?value=${value}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.typeOption = res.data.data.data;
                }
            })
        },
        // 文件上传时勾子
        handleChangeGYS(file, fileList){
            this.fileListGYS = fileList;
        },
        handleChangeFP(file, fileList){
            this.fileListFP = fileList.filter(item => item.name.includes('发票'))
            // 如果有不符合条件的文件，给出提示
            const invalidFiles = fileList.filter(item => !item.name.includes('发票'))
            if (invalidFiles.length > 0) {
                this.$message.warning(`有 ${invalidFiles.length} 个文件因名称不含"发票"已被过滤`)
            }
        },
        handleChangeBGD(file, fileList){
            this.fileListBGD = fileList;
        },
        handleChangeQT(file, fileList){
            this.fileListQT = fileList;
        },
        // 移除文件勾子
        handleRemoveGYS(file, fileList){
            this.fileListGYS = fileList;
        },
        handleRemoveBGD(file, fileList){
            this.fileListBGD = fileList;
        },
        handleRemoveQT(file, fileList){
            this.fileListQT = fileList;
        },
        handleRemoveFP(file, fileList){
            this.fileListFP = fileList;
        },
        // 点击打开选择文件遮罩层
        fileTypeAdd(){
            // 判断是否上传保存单据
            this.dialogFormVisible = true;
        },
    },
}
</script>

<style lang="css" scoped>
::v-deep .el-table .el-table__cell {
    padding: 1.1px 0;
}
.el-form-item__error {
    padding-top: 0;
}
::v-deep .el-dialog__body{
    padding: 0;
}
::v-deep .el-dialog{
    margin-top: 40px !important;
}
.width_250{
    width:250px;
}
/* 超出显示省略号 */
.ellipsis{
    display: block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>